import ReactGA from 'react-ga4';
import { useCallback } from 'react';

export const logEvent = (
  action: string,
  params: Record<string, any> = {}
) => {
  ReactGA.event(action, {
    ...params,
    environment: process.env.NODE_ENV,
  });
};

export const useAnalyticsEvent = () => {
  return useCallback(
    (action: string, params?: Record<string, any>) => {
      logEvent(action, params);
    },
    []
  );
};

